module.exports = BD.Model.extend({
    subject: BD.belongsToReference(),
    modifier: BD.belongsToReference(),
    amount: BD.attr('number', { readonly: true }),
    entryDate: BD.attr('date', { readonly: true }),
    realizedCurrencyDifference: BD.attr('number', { readonly: true }),
    isVoided: BD.attr('boolean', { readonly: true })
})
